import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ArReportsAccessStore } from './ar-reports-access.store';

/** Guard/sidebar compatibility facade. Session-scoped access is owned by the store. */
@Injectable({ providedIn: 'root' })
export class ArReportsAccessService {
  private readonly store = inject(ArReportsAccessStore);
  readonly hasAccess = this.store.hasAccess;
  canAccess(): Observable<boolean> {
    return this.store.canAccess();
  }
}
